import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import messages from '../../../messages';
import FlexBox from '../../../../../../components/FlexBox';
import OptionsContainer from '../../../../components/OptionsContainer';
import Textbox from '../../../../components/Textbox';
import RadioInput from './RadioInput';
import CheckboxInput from './CheckboxInput';

const ElectronicConsentSection = ({
  electronicConsentDocument,
  emailAddress,
  errorEmails,
  signature,
  isMultipleClaimFor,
  isReadOnly,
  handleChange,
  intl,
}) => (
  <div>
    <div className="row">
      <div className="form-group col-md-8 col-sm-12">
        <span>
          <a
            href="https://www.mysurego.com/terms-and-conditions/"
            target="_blank"
            style={{ color: 'blue' }}
            rel="noopener noreferrer"
          >
            <FormattedMessage {...messages.OnlineConsentDoc} id={messages.OnlineConsentDoc.id} />
          </a>
        </span>
      </div>
      <div className="form-group col-md-12">
        <FlexBox>
          <RadioInput
            name="electronicConsentDocument"
            value="true"
            checked={electronicConsentDocument === 'true'}
            onChange={handleChange('form.electronicConsentDocument')}
            disabled={isReadOnly}
            message={messages.yes}
          />
          <RadioInput
            name="electronicConsentDocument"
            value="false"
            checked={electronicConsentDocument === 'false'}
            onChange={handleChange('form.electronicConsentDocument')}
            disabled={isReadOnly}
            message={messages.no}
          />
          {isMultipleClaimFor && (
            <OptionsContainer>
              <FormattedMessage {...messages.agreeSureGoPolicyv2} />
            </OptionsContainer>
          )}
          {!isMultipleClaimFor && (
            <OptionsContainer>
              <FormattedMessage {...messages.agreeSureGoPolicy} id={messages.agreeSureGoPolicy.id} />
            </OptionsContainer>
          )}
        </FlexBox>
      </div>
      <div className="form-group col-md-8 col-sm-12">
        <span>
          <FormattedMessage {...messages.iHaveReadAndAgree} id={messages.iHaveReadAndAgree.id} />
        </span>
      </div>
      {(electronicConsentDocument === 'true' && !isMultipleClaimFor) && (
        <div className="col-sm-8 form-group">
          <span>
            <FormattedMessage {...messages.theEmailAddressToBeUsed} id={messages.theEmailAddressToBeUsed.id} />
          </span>
          <Textbox
            disabled={isReadOnly}
            name="emailAddress"
            type="email"
            onChange={handleChange('form.emailAddress')}
            value={emailAddress}
          />
          {errorEmails && <p style={{ color: 'red', fontSize: '13px' }}>{errorEmails}</p>}
        </div>
      )}
      <div className="form-group col-md-8 col-sm-12">
        <CheckboxInput
          name="signature"
          checked={signature === true}
          onChange={handleChange('form.signature')}
          disabled={isReadOnly}
          message={messages.agree}
          messageId={messages.agree.id}
        />
      </div>
    </div>
  </div>
);

ElectronicConsentSection.propTypes = {
  electronicConsentDocument: PropTypes.bool.isRequired,
  emailAddress: PropTypes.any.isRequired,
  errorEmails: PropTypes.any,
  signature: PropTypes.bool.isRequired,
  isMultipleClaimFor: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

ElectronicConsentSection.defaultProps = {
  errorEmails: null,
};

export default injectIntl(ElectronicConsentSection);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/SubmitClaim/components/ElectronicConsentSection.js